import axios from 'axios';
import { clearSession } from './auth';

// SaleSmart backend (AnainfoIn/salesmart-BE). REACT_APP_API_HOST overrides it,
// e.g. http://localhost:5000 when running the backend locally.
export const API_HOST = (process.env.REACT_APP_API_HOST || 'https://shopify.anainfo.ai').replace(/\/+$/, '');
const BASE = API_HOST;

// Admin API — attaches admin token automatically
const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // An expired or invalid admin token sends the admin back to the login page.
    // The login call itself also returns 401 on bad credentials, so skip it.
    const isLoginCall = err.config?.url?.endsWith('/api/admins/login');
    if (err.response?.status === 401 && !isLoginCall) {
      clearSession();
      if (window.location.pathname !== '/login') window.location.href = '/login';
    }
    return err.response || err;
  }
);

// User API — attaches end-user token (used in PlaceOrder flow)
export const userApi = axios.create({ baseURL: BASE });

userApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('user_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// The interceptor above resolves error responses instead of throwing, so pages
// that need a real failure call this: it returns the body of a successful
// response and throws an Error carrying the backend's message otherwise.
export const unwrap = (res) => {
  const body = res?.data;
  if (!res?.status || res.status >= 400 || body?.success === false) {
    const msg = body?.errors?.[0]?.message || body?.message || res?.message || 'Request failed';
    throw new Error(msg);
  }
  return body;
};

// List endpoints return { success, data: [...], pagination }; older ones return a bare array.
export const listOf = (body) => (Array.isArray(body) ? body : Array.isArray(body?.data) ? body.data : []);

export default api;
